<template>
  <v-dialog v-model="trigger" max-width="768">
    <v-card>
      <v-card-title class="text-h5 primary white--text">
        {{
          service == null
            ? "Agregar nuevo servicio"
            : "Editar " + service.attributes.descripcion
        }}
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel" class="white--text" icon outlined>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="serviceData.codigo" label="Código" dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="serviceData.descripcion"
                  :rules="[required]"
                  dense
                >
                  <template #label>
                    <span
                      >Descripción<strong class="red--text"> *</strong></span
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="serviceData.unidad"
                  :items="unidades"
                  :rules="[required]"
                  hint="FLE para fletes. SER para otros"
                  persistent-hint
                  dense
                >
                  <template #label>
                    <span>Unidad<strong class="red--text"> *</strong></span>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="serviceData.precio_lista"
                  :rules="[requiredAndNotZero]"
                  type="number"
                  dense
                >
                  <template #label>
                    <span>
                      Precio lista
                      <strong class="red--text"> *</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel">
          <v-icon>mdi-close-circle-outline</v-icon>Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="accent" :disabled="!valid" @click="emitDataEntered">
          <v-icon>{{ service == null ? "mdi-plus" : "mdi-pencil" }}</v-icon
          >{{ service == null ? "Agregar" : "Editar" }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "@/helpers/formHelpers";

export default {
  props: {
    service: Object,
    trigger: Boolean,
  },
  data() {
    return {
      valid: false,
      unidades: ["SER", "FLE"],
      requiredAndNotZero: (v) => {
        if (v === null || v === undefined || v === "") {
          return "Este campo es requerido";
        }
        if (v < 0) {
          return "Min. 0";
        }
        return true;
      },
      required,
    };
  },
  computed: {
    serviceData: {
      get() {
        return {
          id: this.service != null ? this.service.id : null,
          codigo: this.service != null ? this.service.attributes.codigo : null,
          descripcion:
            this.service != null ? this.service.attributes.descripcion : null,
          precio_lista:
            this.service != null ? this.service.attributes.precio_lista : null,
          unidad: this.service != null ? this.service.attributes.unidad : null,
        };
      },
    },
  },
  methods: {
    emitDataEntered() {
      if (this.service == null) {
        this.$emit("onAddRequest", this.serviceData);
        return;
      }
      this.$emit("onEditRequest", this.serviceData);
    },
    emitCancel() {
      this.$emit("onCancel");
    },
  },
};
</script>